import { render, staticRenderFns } from "./DiscountCoupon.vue?vue&type=template&id=51c598ec&scoped=true"
import script from "./DiscountCoupon.vue?vue&type=script&lang=js"
export * from "./DiscountCoupon.vue?vue&type=script&lang=js"
import style0 from "./DiscountCoupon.vue?vue&type=style&index=0&id=51c598ec&prod&lang=scss"
import style1 from "./DiscountCoupon.vue?vue&type=style&index=1&id=51c598ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c598ec",
  null
  
)

export default component.exports